import { Signatories } from "../view/signatories/signatories";
import {
  SignRegistrationForExternalSignPageFragment,
  SigningStatus,
} from "gql/graphql";
import { EditFileWithOnlyOffice } from "@/modules/document-register/features/edit-file-with-only-office";
import { CSSProperties, useState } from "react";
import Card from "@/shared/data-display/card";
import { SignButtonInModal } from "@/modules/gateway/features/open-external-sign/ui/sign-button/sign-button-in-modal";
import { useTranslations } from "use-intl";
import { RejectExternalSigningButton } from "@/modules/gateway/features/open-external-sign/ui/reject-button/reject-external-signing-button";
import { RejectedResult } from "@/modules/gateway/features/open-external-sign/view/rejected-result/rejected-result";
import { DocumentToSignView } from "@/modules/gateway/features/open-external-sign/view/document-to-sign/document-to-sign-view";

export default function ExternalSignPage({
  signRegistration,
}: {
  signRegistration: SignRegistrationForExternalSignPageFragment;
}) {
  const t = useTranslations("Signing");
  const [activeDocumentId, setActiveDocumentId] = useState(
    () => signRegistration.documents.at(0)?.id,
  );

  const isRejected = signRegistration.status === SigningStatus.Rejected;

  const activeDocument = signRegistration.documents.find(
    (doc) => doc.id === activeDocumentId,
  );

  return (
    <div
      style={
        {
          "--height": "80vh",
        } as CSSProperties
      }
      className={"grid xl:grid-cols-[2fr_1fr] gap-5"}
    >
      <div className={"order-2 xl:order-1"}>
        <Card
          title={activeDocument?.fileTitle}
          classNames={{
            body: "!p-0",
          }}
        >
          {activeDocument?.file.id && (
            <div className={"h-[--height]"}>
              <EditFileWithOnlyOffice
                fileId={activeDocument?.file.id}
                canEdit={false}
                type={"embedded"}
              />
            </div>
          )}
        </Card>
      </div>

      <div className={"order-1 xl:order-2"}>
        <Card title={t("Signing Dashboard")}>
          <div className={"grid gap-y-6"}>
            {isRejected ? (
              <RejectedResult />
            ) : (
              <div className={"flex gap-2"}>
                <SignButtonInModal signRegistration={signRegistration} />
                {signRegistration.canReject && <RejectExternalSigningButton />}
              </div>
            )}

            <DocumentToSignView
              signRegistration={signRegistration}
              setActiveId={setActiveDocumentId}
              activeId={activeDocumentId}
            />
            <Signatories signRegistration={signRegistration} />
          </div>
        </Card>
      </div>
    </div>
  );
}
